import {baseAxios} from '../helper/axiosHelper';

export const userdefinedOptionsService = {
    getUserdefinedOptionsAll,
    getUserdefinedOptions,
    deleteUserdefinedOption,
    insertUserdefinedOption
};

function getUserdefinedOptionsAll() {

    return baseAxios.get('company/userdefinedoptions/all/')
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}
function getUserdefinedOptions(type) {

    return baseAxios.get('company/userdefinedoptions/',{params: {type: type}})
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}

function deleteUserdefinedOption(id) {

    return baseAxios.delete('company/userdefinedoption/',{params: {id: id}}  )
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}

function insertUserdefinedOption(data) {

    return baseAxios.post('company/userdefinedoption/',data )
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}

